import {GET_PROMO_LIST,GET_REMINDER_LIST,GET_BIRTHDAY_LIST,GET_CLIENT_LIST,GET_GROUP_LIST,
  GET_PROMO_LIST_EXPIRED ,GET_PROMOTION_DETAIL ,GET_REMINDER_DETAIL, GET_BIRTHDAY_DETAIL, GET_CAMPAIGN_HISTORY_LIST} from "./promoListTypes";
import { Promotion } from "../../models/campaign/promotion";
import { Reminder } from "../../models/campaign/reminder";
import { Birthday } from "../../models/campaign/birthday";
import { NewClient } from "../../models/campaign/new_client";

export default {
    [GET_PROMO_LIST](state, data) {
      state.promoData = data;
      let promo_arr = [];
      if(data != null) {
        for(let i = 0; i < data.items.length; i++) {
          promo_arr.push(new Promotion(data.items[i]));
        }
      }
      state.promoList = promo_arr;
    },

    [GET_PROMO_LIST_EXPIRED](state, data) {
      state.promoDataExpired = data;
      let promo_arr = [];
      if(data != null) {
        for(let i = 0; i < data.items.length; i++) {
          promo_arr.push(new Promotion(data.items[i]));
        }
      }
      state.promoListExpired = promo_arr;
    },

    [GET_REMINDER_LIST](state,data) {
      state.reminderData = data;
      let reminder_arr = [];
      if(data != null) {
        for(let i = 0; i < data.items.length; i++) {
          reminder_arr.push(new Reminder(data.items[i]));
        }
      }
      state.reminderList = reminder_arr;
    },

    [GET_BIRTHDAY_LIST](state, data) {
      state.birthdayData = data;
      let birthday_arr = [];
      if(data != null) {
        for(let i = 0; i < data.items.length; i++) {
          birthday_arr.push(new Birthday(data.items[i]));
        }
      }
      state.birthdayList = birthday_arr;
    },

    [GET_CLIENT_LIST](state,data){
      state.newClient = new NewClient(data);
    },

    [GET_GROUP_LIST](state,data){
      state.groupList = data
    },

    [GET_PROMOTION_DETAIL](state,data){
      state.promotionInfo = data;
    },
    [GET_REMINDER_DETAIL](state,data){
      state.reminderInfo = data;
    },
    [GET_BIRTHDAY_DETAIL](state,data){
      state.birthdayInfo = data;
    },
    [GET_CAMPAIGN_HISTORY_LIST](state, data) {
      state.campaignHistoryList = data;
    }
  }
